<template>
    <payments-find
        :params="{ payment: $route.params.payment }"
        :include="[
            'charge(include:fees(include:property),payer,rents(include:property))',
            'transaction(include:payout)',
        ]"
    >
        <div
            slot-scope="{
                is_loading,
                has_loaded,
                error,
                data: payment,
                find
            }"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <grid-layout>
                    <grid-layout-item class="mb-6 md:w-2/3">
                        <details-card class="md:h-full">
                            <template slot="header">
                                <h1 class="text-lg font-normal">
                                    Money In
                                </h1>
                            </template>

                            <template slot="body">
                                <grid-layout>
                                    <grid-layout-item class="mb-3 sm:w-1/2 lg:w-1/3">
                                        <div class="text-xs text-label">From</div>
                                        <div class="text-sm">
                                            {{ payment.charge.payer.name }}
                                        </div>
                                    </grid-layout-item>
                                </grid-layout>
                            </template>
                        </details-card>
                    </grid-layout-item>

                    <grid-layout-item class="mb-6 md:w-1/3">
                        <div class="flex flex-col h-full bg-white rounded shadow">
                            <header class="flex items-center flex-none h-16 px-4 border-b md:h-18 sm:px-6">
                            <h3 class="flex-grow text-base font-normal">Amount</h3>

                                <span
                                    :class="['bg-green-lighter', 'text-green-darker']"
                                    class="flex-none px-3 py-1 text-sm font-semibold rounded-full"
                                >
                                    {{ payment.transaction.payout ? 'Paid' : 'Pending' }}
                                </span>
                            </header>

                            <div class="flex items-center flex-grow p-4 leading-none sm:p-6">
                                <div class="flex-none">
                                    <div class="text-3xl font-semibold">{{ payment.amount | money(0) }}</div>
                                    <div class="text-xs text-grey-darker">minus {{ payment.fee | money(0) }} fee</div>
                                </div>
                            </div>
                        </div>
                    </grid-layout-item>
                </grid-layout>

                <payment-summary-card
                    :rents="payment.charge.rents.data"
                    :fees="payment.charge.fees.data"
                />
            </template>
        </div>
    </payments-find>
</template>

<script>
    import DetailsCard from '../../../../components/details-card'
    import PaymentsFind from '../../../../components/payments-find'
    import PaymentSummaryCard from '../../../../components/payment-summary-card'

    export default {
        components: {
            DetailsCard,
            PaymentsFind,
            PaymentSummaryCard
        }
    }
</script>
